/* eslint-disable react/prop-types, react/no-unstable-nested-components */
// import { Fetch } from "react-request";
import React, { useMemo, useState } from 'react';

import { ThreeDotsVertical } from 'react-bootstrap-icons';
import { Row, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import 'moment-timezone';

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import TimeChange from '../../components/TimeChange';
import Status from '../../components/Status';
import JobTable from './JobTables';

import { listJobs, killJob } from './api';
import CreateJob from './CreateJob';
import ShowDRLogs from './ShowDRJobLogs';
import KillJobModal from './KillJobModal';
import Modal from './Modals/Modal';
import { FilterProvider } from '../Filters/FilterContext';

const statusVal = ({ cell: { value } }) => <Status state={value} />;
const submittedTime = ({ cell: { value } }) => <TimeChange date={value} />;
const endTime = ({ cell: { value } }) =>
  value != null ? <TimeChange date={value} /> : null;

const resultLink = ({ cell: { value } }) => (
  <a href={value} target="_blank" rel="noopener noreferrer">
    Link
  </a>
);

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button
    className="toggleButtonDropdown"
    style={{ background: 'none', border: 'none' }}
    type="button"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
    <ThreeDotsVertical />
  </button>
));

const Jobs = () => {
  const [showLogsFlag, setShowLogsFlag] = useState({
    open: false,
    jobId: null,
    jobParams: {},
  });

  const [jobKillFlag, setJobKillFlag] = useState({
    openModal: false,
    jobStateMachineId: null,
  });

  const [modalInfo, setModalInfo] = useState({
    openModal: false,
    heading: '',
    body: '',
  });

  const queryClient = useQueryClient();
  const [pageNumber, setPageNumber] = useState(1);
  const query = useQuery(['listJobs', pageNumber], () => listJobs(pageNumber), {
    refetchInterval: 5000,
    refetchIntervalInBackground: false,
    keepPreviousData: true,
  });

  const killJobMutation = useMutation(killJob, {
    onSuccess: () => {
      queryClient.invalidateQueries(['listJobs', pageNumber]);
    },
  });

  const showLogsHandler = async (row) => {
    setShowLogsFlag({
      open: true,
      jobId: row.id,
      jobParams: row.job_params,
    });
  };

  const closeShowLogs = () => {
    setShowLogsFlag({
      open: false,
      jobId: null,
      jobParams: {},
    });
  };
  const killJobHandler = (jobId) => {
    killJobMutation.mutate({
      jobId,
    });
  };

  const jobColumns = useMemo(
    () => [
      {
        Header: 'Job ID',
        accessor: 'id',
      },
      {
        Header: 'Job Type',
        accessor: 'type',
        Cell: ({ value }) => value?.replaceAll('_', ' '),
      },
      {
        Header: 'Job Params',
        accessor: 'params',
        Cell: ({ value }) =>
          Object.keys(value).map((item) => (
            <div key={item}>
              <span style={{ fontWeight: 600 }}>{item}</span>: {value[item]}
            </div>
          )),
      },
      {
        Header: 'Status',
        accessor: 'status',
        // Cell: ({ cell: { value } }) => <Status value={value} />,
        Cell: statusVal,
      },
      {
        Header: 'Total Step',
        accessor: 'total_step',
      },
      {
        Header: 'Submitted At',
        accessor: 'submitted_time',
        // Cell: ({ cell: { value } }) => <TimeChange date={value} />,
        Cell: submittedTime,
      },
      {
        Header: 'Ended At',
        accessor: 'end_time',
        // Cell: ({ cell: { value } }) =>
        //   value != null ? <TimeChange date={value} /> : null,
        Cell: endTime,
      },
      {
        Header: 'Result',
        accessor: 'result.props.compare_link',
        // Cell: ({ cell: { value }, row: { values } }) => (
        //   <a href={value} target="_blank" rel="noopener noreferrer">
        //     Link
        //   </a>
        // ),
        Cell: resultLink,
      },
    ],
    []
  );

  if (query.isLoading) {
    return (
      <div className="loading">
        <img alt="logo" src="/logo.png" />
      </div>
    );
  }

  if (query.isError) {
    return <div>The request did not succeed.</div>;
  }

  if (query.data) {
    return (
      <Container>
        <Row>
          {/* Add a link to navigate to "jobs_old_data" */}
          <Link
            style={{
              color: '#007bff',
              padding: '10px',
              marginTop: '10px',
              textDecoration: 'none',
            }}
            to="/jobs_old"
          >
            Old Jobs Data
          </Link>
        </Row>
        <Row>
          <div className="mt-3 ml-0">Start New Job</div>
        </Row>
        <Row>
          <CreateJob
            onSuccess={() => {
              setModalInfo({
                openModal: true,
                heading: 'Success 🥳',
                body: 'Job is now submitted successfully',
              });
              setPageNumber(1);
              queryClient.invalidateQueries(['listJobs', pageNumber]);
            }}
            onL2AError={() => {
              setModalInfo({
                openModal: true,
                heading: 'Error ❌',
                body: 'Please provide the correct mgrs tile and date with index',
              });
            }}
            onError={() => {
              setModalInfo({
                openModal: true,
                heading: 'Error ❌',
                body: 'Something went wrong, please try again',
              });
            }}
            onOrthoMoreError={(ortho) => {
              setModalInfo({
                openModal: true,
                heading: 'Error ❌',
                body: ortho.Reason,
              });
            }}
            onOrthoLessError={(ortho) => {
              setModalInfo({
                openModal: true,
                heading: 'Error ❌',
                body: ortho.Reason,
              });
            }}
            onOrthoError={(ortho) => {
              setModalInfo({
                openModal: true,
                heading: 'Error ❌',
                body: ortho.Reason,
              });
            }}
            onOrthoOldFileError={(ortho) => {
              setModalInfo({
                openModal: true,
                heading: 'Error ❌',
                body: ortho.Reason,
              });
            }}
            onOthoprepFileCheckSuccess={() => {
              setModalInfo({
                openModal: true,
                heading: 'Success 🥳',
                body: '1. Version ✅ 2. Files - 225 ✅',
              });
            }}
            onNotFoundError={() => {
              setModalInfo({
                openModal: true,
                heading: 'Error ❌',
                body: '404 Error: Not found. Please check the connections of backend',
              });
            }}
            onOrthoVersionFoundError={() => {
              setModalInfo({
                openModal: true,
                heading: 'Error ❌',
                body: 'Ortho-prep not found. Please create the ortho-prep first',
              });
            }}
          />
        </Row>
        <Row>
          <FilterProvider>
            <JobTable
              columns={jobColumns}
              data={query.data.list}
              dataUpdatedAt={query.dataUpdatedAt}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              count={query.data.count}
              showLogsHandler={showLogsHandler}
              setJobKillFlag={setJobKillFlag}
            />
          </FilterProvider>
        </Row>
        {showLogsFlag.open && (
          <ShowDRLogs
            show={showLogsFlag.open}
            handleClose={closeShowLogs}
            jobParams={showLogsFlag.jobParams}
            jobId={showLogsFlag.jobId}
          />
        )}

        <KillJobModal
          killJobHandler={killJobHandler}
          jobKillFlag={jobKillFlag}
          setJobKillFlag={setJobKillFlag}
        />

        <Modal
          show={modalInfo.openModal}
          onHide={() =>
            setModalInfo({
              openModal: false,
              heading: '',
              body: '',
            })
          }
          heading={modalInfo.heading}
          message={modalInfo.body}
        />
      </Container>
    );
  }
};

CustomToggle.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
};

Status.propTypes = {
  value: PropTypes.string,
};

Jobs.propTypes = {};

export default Jobs;
